export default {"src":"/_next/static/media/robo.da59eaeb.svg","height":32,"width":260,"blurWidth":0,"blurHeight":0};